import { useQuery } from '@tanstack/react-query';
import { apiGet, qk } from './_client';

/** GET /api/films/{id}/crew — film crew roster. */
export function useFilmCrew(filmId, options = {}) {
  const { enabled, ...rest } = options;
  return useQuery({
    queryKey: qk.filmCrew(filmId),
    queryFn: ({ signal }) => apiGet(`/films/${filmId}/crew`, signal),
    enabled: !!filmId && (enabled ?? true),
    ...rest,
  });
}
